import React, { useState, useEffect } from "react";
import { createCertificate, fetchCertificates, updateCertificate, deleteCertificate } from "../../../../../services/experienceService";

const CertificateList = ({ profileId, initialCertificates }) => {
    const [certificates, setCertificates] = useState(initialCertificates || []);
    const [editingIndex, setEditingIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [mouseDownOutside, setMouseDownOutside] = useState(false);

    const [tempCertificate, setTempCertificate] = useState({
        title: "",
        issuing_organization: "",
        issue_date: "",
    });
    
    // Save (Add or Update)
    const handleSave = async () => {
        try {
            setLoading(true);

            if (isAdding) {
                const payload = { ...tempCertificate, profile: profileId };
                const newCert = await createCertificate(payload);
                setCertificates((prev) => [newCert, ...prev]);
            } else if (editingIndex !== null) {
                const certId = certificates[editingIndex].id;
                const updated = await updateCertificate(certId, tempCertificate);

                setCertificates((prev) =>
                    prev.map((c, i) => (i === editingIndex ? updated : c))
                );
            }

            closeModal();
        } catch (err) {
            console.error(err);
            alert("Failed to save certificate.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (index) => {
        const certId = certificates[index].id;

        if (!window.confirm("Are you sure you want to delete this certificate?")) return;

        try {
            await deleteCertificate(certId);
            setCertificates((prev) => prev.filter((_, i) => i !== index));
        } catch (err) {
            console.error("Failed to delete certificate:", err);
            alert("Failed to delete certificate.");
        }
    };

    const openAddModal = () => {
        setIsAdding(true);
        setEditingIndex(null);
        setTempCertificate({ title: "", issuing_organization: "", issue_date: "" });
        setShowModal(true);
    };

    const openEditModal = (index) => {
        setIsAdding(false);
        setEditingIndex(index);
        setTempCertificate({ ...certificates[index] });
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setIsAdding(false);
        setEditingIndex(null);
    };

    return (
        <>
            <div className="experience-block">
                {/* Header */}
                <div className="experience-header-row">
                    <h3 className="experience-title">Certificates</h3>
                    <button className="add-certificate-top-btn" onClick={openAddModal}>
                        + Add
                    </button>
                </div>

                {/* Certificate Cards */}
                {certificates.map((cert, index) => (
                    <div key={cert.id} className="experience-license-card">
                        <div className="license-field">
                            <span className="license-label">Title:</span> {cert.title}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Organization:</span>{" "}
                            {cert.issuing_organization}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Issued:</span> {cert.issue_date}
                        </div>

                        <div className="experience-license-icons">
                            <i
                                className="fa-solid fa-pen"
                                onClick={() => openEditModal(index)}
                            ></i>

                            {/* delete later */}
                            <i
                                className="fa-solid fa-trash"
                                onClick={() => handleDelete(index)}
                            ></i>
                        </div>
                    </div>
                ))}


            </div>
            {/* ----------------------- MODAL ----------------------- */}
            {showModal && (
                <div
                    className="experience-modal-backdrop"

                    onMouseDown={(e) => {
                        // Mouse down must BEGIN on the backdrop ONLY
                        if (e.target.classList.contains("experience-modal-backdrop")) {
                            setMouseDownOutside(true);
                        } else {
                            setMouseDownOutside(false);
                        }
                    }}

                    onMouseUp={(e) => {
                        // Only close if mouse down & mouse up BOTH happened on backdrop
                        if (
                            mouseDownOutside &&
                            e.target.classList.contains("experience-modal-backdrop")
                        ) {
                            closeModal();
                        }
                        setMouseDownOutside(false); // Reset tracking
                    }}
                >
                    <div
                        className="experience-modal-content"
                        onClick={(e) => e.stopPropagation()} // Don't close when clicking inside
                    >
                        <h3 className="freelancer-modal-title">
                            {isAdding ? "Add Certificate" : "Edit Certificate"}
                        </h3>

                        <div className="form-group">
                            <label>Title:</label>
                            <input
                                type="text"
                                value={tempCertificate.title}
                                onChange={(e) =>
                                    setTempCertificate({
                                        ...tempCertificate,
                                        title: e.target.value,
                                    })
                                }
                                className="experience-input"
                            />
                        </div>

                        <div className="form-group">
                            <label>Issuing Organization:</label>
                            <input
                                type="text"
                                value={tempCertificate.issuing_organization}
                                onChange={(e) =>
                                    setTempCertificate({
                                        ...tempCertificate,
                                        issuing_organization: e.target.value,
                                    })
                                }
                                className="experience-input"
                            />
                        </div>

                        <div className="form-group">
                            <label>Issue Date:</label>
                            <input
                                type="date"
                                value={tempCertificate.issue_date}
                                onChange={(e) =>
                                    setTempCertificate({
                                        ...tempCertificate,
                                        issue_date: e.target.value,
                                    })
                                }
                                className="experience-input"
                            />
                        </div>

                        <div className="experience-btn-group">
                            <button
                                className="save-btn"
                                onClick={handleSave}
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save"}
                            </button>
                            <button className="cancel-btn" onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
};

export default CertificateList;